import React, { useEffect, useRef, useState } from "react";
import {
  createMediaObjectUrl,
  fetchMediaBlob,
  revokeMediaObjectUrl,
} from "../../services/media";

function AuthenticatedMedia({
  path,
  alt = "",
  className,
  loading,
  decoding,
  onClick,
  fallback = null,
  loadingFallback = null,
  keepPrevious = false,
  ...rest
}) {
  const [objectUrl, setObjectUrl] = useState("");
  const [mediaState, setMediaState] = useState("idle");
  const objectUrlRef = useRef("");

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const clearCurrentMedia = () => {
      const currentObjectUrl = objectUrlRef.current;
      objectUrlRef.current = "";
      setObjectUrl("");
      revokeMediaObjectUrl(currentObjectUrl);
    };

    setMediaState("loading");
    if (!path) {
      clearCurrentMedia();
      setMediaState("error");
      return () => controller.abort();
    }

    if (!keepPrevious) clearCurrentMedia();

    fetchMediaBlob(path, { signal: controller.signal })
      .then((blob) => {
        if (!active) return;
        const nextObjectUrl = createMediaObjectUrl(blob);
        const previousObjectUrl = objectUrlRef.current;
        objectUrlRef.current = nextObjectUrl;
        setObjectUrl(nextObjectUrl);
        setMediaState("ready");
        revokeMediaObjectUrl(previousObjectUrl);
      })
      .catch(() => {
        if (!active) return;
        clearCurrentMedia();
        setMediaState("error");
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [keepPrevious, path]);

  useEffect(() => () => {
    revokeMediaObjectUrl(objectUrlRef.current);
    objectUrlRef.current = "";
  }, []);

  if (!objectUrl) {
    if (mediaState === "loading" && loadingFallback) return loadingFallback;
    if (fallback) return fallback;

    return (
      <span
        className={className}
        role="img"
        aria-label={alt || "Mídia protegida"}
        onClick={onClick}
        {...rest}
      />
    );
  }

  return (
    <img
      {...rest}
      src={objectUrl}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      onClick={onClick}
    />
  );
}

export default AuthenticatedMedia;
